enum ESymbol {
    EURO = "€",
    EURO_ISO = "EUR",
    PERCENT = "%",
    SPACE = " ",
    SPACE_HTML = "&nbsp;" // non-breaking space -> hilfreich bei Einheiten, die unmittelbar nach einer Zahl stehen und nicht umgebrochen werden sollen
}

export default ESymbol;
